
import { Component, Vue } from 'vue-property-decorator';
import Alert from '~/components/Alerts/Alert.vue';
import OneTimePayment from '@/components/Payments/OneTimePayment.vue';
import Transactions from '@/components/Transactions/Transactions.vue';
import ResponsiveContainer from '@/components/Layout/ResponsiveContainer.vue';

@Component({
  components: {
    Alert,
    OneTimePayment,
    Transactions,
    ResponsiveContainer,
  }
})
export default class HomeView extends Vue {
  get accountLastFour() {
    return this.$store.getters['Account/getBankAccountLastFour'];
  }
}
